//FUNCIONS
import React from 'react';
//HOOKS
import AppProvider from './hooks';
//TYPES

//COMPONENTS
import Account from '../NewAccount/Account';
//STYLES

const NewAccount: React.FC = () => {
  return (
    <AppProvider>
      <Account />
    </AppProvider>
  );
}

export default NewAccount;
